import * as THREE from 'three';

// Screen space quad that is ordered & setup to execute its material to update
// the stencil buffer and to enable it to be used by the scene.
// NOTES:
// - Any material used should not have transparent turned on
// - Fragment shader should be using discard to set stencil pixel to 0
export default function screenStencilQuad(
  mat: THREE.Material,
  order: number = -100,
): THREE.Mesh {
  const mesh = new THREE.Mesh(new THREE.PlaneGeometry(2, 2, 1), mat);
  mesh.renderOrder = order; // Usually set it last for rendering
  mesh.frustumCulled = false; // Easily gets culled from frustum tests, disable it

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  mesh.onBeforeRender = (
    renderer,
    scene,
    camera,
    geometry,
    material,
    group,
  ) => {
    const ctx = renderer.getContext();

    // Clear stencil buffer
    ctx.clear(ctx.STENCIL_BUFFER_BIT); // ctx.clearStencil( 0 );

    // Enable stencil test
    ctx.enable(ctx.STENCIL_TEST);

    // Always write 1 to the stencil buffer for this pass
    ctx.stencilFunc(ctx.ALWAYS, 1, 0xff); // Always pass and write 1 into the stencil buffer
    ctx.stencilOp(ctx.REPLACE, ctx.REPLACE, ctx.REPLACE); // Replace stencil value with 1

    // Disable color and depth writing, we only care about the stencil buffer here
    ctx.colorMask(false, false, false, false);
    ctx.depthMask(false); // Disable depth writing
    ctx.stencilMask(0xff); // Affect all stencil bits
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  mesh.onAfterRender = (renderer, scene, camera, geometry, material, group) => {
    const ctx = renderer.getContext();

    // Restore color and depth writing
    ctx.colorMask(true, true, true, true);
    ctx.depthMask(true); // Re-enable depth writing

    // Set the stencil function to only render where the stencil value is 1
    ctx.stencilFunc(ctx.EQUAL, 1, 0xff); // Only render where stencil value is 1
    ctx.stencilOp(ctx.KEEP, ctx.KEEP, ctx.KEEP); // Keep stencil values

    // Optional: mask stencil buffer to stop affecting certain bits
    // ctx.stencilMask(0xff);  // All stencil bits are active again
  };

  return mesh;
}
